import script from "./Notificacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./Notificacoes.vue?vue&type=script&setup=true&lang=js"

import "./Notificacoes.vue?vue&type=style&index=0&id=27efa3ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27efa3ee"]])

export default __exports__